import { jsx as _jsx } from "react/jsx-runtime";
import { useTrackClickedEllipsisMenuButton } from "@air/analytics";
import { Ellipsis as EllipsisHorizontalIcon } from "@air/next-icons";
import { itemIsSelectedSelector } from "@air/redux-selected-items";
import { memo, useCallback, useMemo } from "react";
import { flushSync } from "react-dom";
import { CardAction } from "~/components/CardAction";
import { CardEllipsisMenu } from "~/components/Gallery/CardEllipsisMenu";
import { BOARD_CARD_MENU, BOARD_CARD_MENU_BUTTON } from "~/constants/testIDs";
import { useAirSelector } from "~/utils/ReduxUtils";
const _BoardGalleryCardMenu = (param)=>{
    let { board, getItemMenuOptions, getSelectionMenuOptions, setIsMenuOpen } = param;
    const { trackClickedEllipsisMenuButton } = useTrackClickedEllipsisMenuButton();
    const isSelected = useAirSelector((st)=>itemIsSelectedSelector(st, board.id));
    const selectionMenuOptions = getSelectionMenuOptions("gallery-multi-select-ellipsis-menu");
    const ellipsisMenuOptions = getItemMenuOptions({
        trackLocation: "gallery-item-ellipsis-menu"
    });
    const onMenuChange = useCallback((isOpen)=>{
        if (isOpen) {
            trackClickedEllipsisMenuButton({
                location: "asset-item"
            });
        }
        flushSync(()=>{
            setIsMenuOpen(isOpen);
        });
    }, [
        setIsMenuOpen,
        trackClickedEllipsisMenuButton
    ]);
    const menuOptions = useMemo(()=>{
        const menuOptionsArray = [];
        if (isSelected && selectionMenuOptions.length) {
            menuOptionsArray.push(...selectionMenuOptions);
        } else {
            menuOptionsArray.push(...ellipsisMenuOptions);
        }
        return menuOptionsArray;
    }, [
        ellipsisMenuOptions,
        isSelected,
        selectionMenuOptions
    ]);
    if (!(menuOptions === null || menuOptions === void 0 ? void 0 : menuOptions.length)) {
        return null;
    }
    return /*#__PURE__*/ _jsx(CardEllipsisMenu, {
        title: "More board options",
        menuProps: {
            options: menuOptions
        },
        onMenuChange: onMenuChange,
        actionSheetTestId: BOARD_CARD_MENU,
        trigger: /*#__PURE__*/ _jsx(CardAction, {
            "data-testid": BOARD_CARD_MENU_BUTTON,
            icon: /*#__PURE__*/ _jsx(EllipsisHorizontalIcon, {
                className: "size-4"
            })
        })
    });
};
export const BoardGalleryCardMenu = /*#__PURE__*/ memo(_BoardGalleryCardMenu);
